module.exports = __webpack_public_path__ + "static/lockdown-paul-551a05157cbf75bfedb549c27868d181.png";